module.exports = __webpack_public_path__ + "static/img/saasbingfa_tubiao.a97130ed.png";